import { TextareaAutosize, withStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import { border, toCssValue } from '@topconagriculture/theme';
import cn from 'classnames';
import * as React from 'react';
import { Text } from '../../Text';
const styles = (theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    textarea: {
        border: border(theme.color.grey.light),
        outline: 'none',
        borderRadius: theme.common.borderRadius.default,
        padding: theme.space.padding.small,
    },
    textError: {
        color: theme.color.error.main,
        padding: toCssValue([theme.space.padding.small, theme.space.padding.smallest]),
    },
    textAreaError: {
        border: `1px solid ${theme.color.error.main}`,
    },
});
export const TEXTAREA_DEFAULT_ROW_SIZE = 4;
const TextArea = ({ classes, className, touched = false, error, testId = 'TextArea', rowsMin = TEXTAREA_DEFAULT_ROW_SIZE, rowsMax = TEXTAREA_DEFAULT_ROW_SIZE, resizable, ...props }) => {
    return (React.createElement("div", { className: classes.root, "data-testid": `${testId}` },
        React.createElement(TextareaAutosize, Object.assign({}, props, { "data-testid": `${testId}-input`, minRows: rowsMin, maxRows: rowsMax, className: cn(classes.textarea, className, touched && error && classes.textAreaError), style: { resize: resizable ? 'block' : 'none' } })),
        touched && error && (React.createElement(Text, { block: true, size: 12, "data-testid": `${testId}-error`, className: classes.textError }, error))));
};
TextArea.displayName = 'TextArea';
export default withStyles(styles)(TextArea);
//# sourceMappingURL=TextArea.js.map